import Main from './DepartmentsMain'
import New from './DepartmentsNew'
import Edit from './DepartmentsEdit'

export default {
  Main,
  New,
  Edit,
}
